(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .value('googleChartApiConfig', {
      optionalSettings: {
        language: 'pt-br',
        packages: ['corechart']
      }
    });

}());
